<div class="w-full h-full py-4 px-5 flex flex-col gap-4 p-5">
  <h3 class="font-bold text-[24px] leading-[32px] flex justify-center items-center">Choose Founders</h3>
  <p class="mt-[15px]">Add a founder from members that you follow.</p>
  <!-- Search -->
  <div class="relative w-full mt-[10px]">
    <ion-icon
      name="search-outline"
      class="absolute left-3 top-3 text-black"
    ></ion-icon>
    <ion-input
      fill="outline"
      color="dark"
      labelPlacement="floating"
      label="Search Members"
      type="text"
      mode="md"
      (ionInput)="onSearchChange($event.detail.value)"
      class="pl-[40px] h-full"
      style="--padding-start: 40px"
    ></ion-input>
  </div>

  <!-- All Following (filtered) -->
   <h6 class="flex justify-start font-semibold leading-[24px] text-[14px]">All Following</h6>
  <div class="flex-1 overflow-y-auto">
    <div
      class="p-4 grid grid-cols-4 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-4"
      *ngIf="availableFounders.length > 0; else noResults"
    >
      <div
        *ngFor="let user of availableFounders"
        (click)="onFounderSelect(user)"
        class="flex flex-col items-center bg-white cursor-pointer"
      >
        <div class="relative w-[50px] h-[50px]">
          <img
            class="w-full h-full rounded-full object-cover border"
            [src]="user.icon || 'https://www.gravatar.com/avatar/?d=mp'"
            [alt]="user.nickname"
          />
        </div>
        <div class="mt-1 text-xs text-center min-w-[50px] max-w-[60px]">
          {{ '@' + user.nickname }}
        </div>
      </div>
    </div>

    <ng-template #noResults>
      <div class="flex justify-center items-center h-full text-gray-400 flex-1 p-5">
        No members found
      </div>
    </ng-template>
  </div>

  <!-- Selected Founders -->
  <div
    *ngIf="selectedFounders.length > 0"
    id="selectedMembers"
    class="relative w-full border border-gray-300 rounded-md h-[140px] bg-white shadow-sm"
  >
    <div class="absolute -top-2 left-3 bg-white px-1">
      <label class="text-black text-xs">Selected Founders</label>
    </div>

    <div class="flex gap-1.5 items-start overflow-x-auto h-full p-2">
      <div
        *ngFor="let founder of selectedFounders"
        class="flex flex-col items-center min-w-[50px] max-w-[60px] mt-[10px]"
      >
        <div class="relative w-[50px] h-[50px]">
          <img
            class="w-full h-full rounded-full object-cover"
            [src]="
              founder.icon
                ? founder.icon
                : 'https://www.gravatar.com/avatar/?d=mp'
            "
            alt="{{ founder.nickname }}'s profile"
          />
          <ion-icon
            name="close-circle"
            class="absolute top-0 right-0 text-red-500 cursor-pointer"
            (click)="removeSelectedFounder(founder)"
          ></ion-icon>
        </div>
        <div class="mt-1 text-xs text-center min-w-[50px] max-w-[60px]">
          {{ '@' + founder.nickname }}
        </div>
      </div>
    </div>
  </div>

  <!-- Finalize Button -->
  <div class="w-full mt-4">
    <ark-button (click)="finalizeSelection()" rightIcon="system-right">
      DONE
    </ark-button>
  </div>
</div>
